import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IItemRecipe } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ItemRecipeService extends BaseService<IItemRecipe> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'itemRecipe');
  }
}

export { IItemRecipe } from '../shared/api';
